module.exports = __webpack_public_path__ + "static/img/get-involeved-2-_24@3x.2d497ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new7/get-involeved-2-_24@3x.png
// module id = 76j8
// module chunks = 1 27